<section>
  <app-admin-page-header>
    <ng-container actions>
      @if (showCreate()) {
        <app-admin-button variant="primary" type="button" (click)="goCreate()" [disabled]="!canCreate()">
          Create franchise
        </app-admin-button>
      }
      <select
        class="cg-select"
        [(ngModel)]="statusFilter"
        name="statusFilter"
        aria-label="Filter by status"
      >
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </ng-container>
  </app-admin-page-header>

  <app-admin-table>
    <thead>
      <tr>
        <th>Franchise ID</th>
        <th>Name</th>
        <th>Code</th>
        <th>Admin email</th>
        <th>Staff</th>
        <th>Leads</th>
        <th>Status</th>
        <th>Created</th>
      </tr>
    </thead>
    <tbody>
      @if (filtered().length === 0) {
        <tr>
          <td colspan="8">
            <app-admin-empty-state icon="users" title="No franchises" description="Create a franchise to get started." />
          </td>
        </tr>
      }
      @for (franchise of filtered(); track franchise.franchiseId ?? franchise.id) {
        <tr>
          <td>{{ franchise.franchiseId || '—' }}</td>
          <td>
            <a [routerLink]="['/platform/franchises', franchise.franchiseId ?? franchise.id]" class="cg-link">{{ franchise.name }}</a>
          </td>
          <td><code>{{ franchise.code }}</code></td>
          <td>{{ franchise.adminEmail }}</td>
          <td>{{ franchise.usersCount }}</td>
          <td>{{ franchise.leadsCount }}</td>
          <td>
            <app-status-badge [variant]="franchise.isActive ? 'published' : 'draft'">
              {{ franchise.isActive ? 'Active' : 'Inactive' }}
            </app-status-badge>
          </td>
          <td>{{ franchise.createdAt ? (franchise.createdAt | date: 'mediumDate') : '—' }}</td>
        </tr>
      }
    </tbody>
  </app-admin-table>
</section>
